import { render, staticRenderFns } from "./Fakture.vue?vue&type=template&id=c6ec54da"
import script from "./Fakture.vue?vue&type=script&lang=js"
export * from "./Fakture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports